const breakpoints = {
    // always list from widest to narrowest
    xxl: 1680,
    xl: 1200,
    l: 992,
    m: 592,
    s: 320
};
export const breakpointKeys = Object.keys(breakpoints);
export default breakpoints;
//# sourceMappingURL=breakpoints.js.map